(function () {
  'use strict';

  /* ── HTML エスケープ ──────────────────────────────────────────────────── */

  function esc(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ── Shopify money フォーマット ──────────────────────────────────────── */

  function formatMoney(cents, fmt) {
    if (!fmt) return String(cents);
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!m) return String(cents);
    var precision = 2, thousands = ',', decimal = '.';
    switch (m[1]) {
      case 'amount_no_decimals':
        precision = 0; break;
      case 'amount_with_comma_separator':
        thousands = '.'; decimal = ','; break;
      case 'amount_no_decimals_with_comma_separator':
        precision = 0; thousands = '.'; decimal = ''; break;
      case 'amount_no_decimals_with_space_separator':
        precision = 0; thousands = ' '; break;
    }
    var num   = (cents / 100.0).toFixed(precision);
    var parts = num.split('.');
    var int   = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    var dec   = parts[1] ? decimal + parts[1] : '';
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, int + dec);
  }

  /* ═══════════════════════════════════════════════════════════════════════
     SummitGrid — Custom Element（トップページ商品グリッド）
  ═══════════════════════════════════════════════════════════════════════ */

  class SummitGrid extends HTMLElement {

    connectedCallback() {
      /* ── 商品データ / カート関連 ────────────────────────────────────── */
      this._products          = this._parseProductsData();
      this._moneyFmt          = this.dataset.moneyFormat || '';
      this._selVariantId      = null;
      this._overlayProductIdx = null;
      this._overlayImgIdx     = 0;
      this._overlayImages     = [];

      this._prodOverlay = document.getElementById('summit-product-overlay');
      this._cartDrawer  = document.getElementById('summit-cart-drawer');

      /* ── イベント設定 ───────────────────────────────────────────────── */
      this._setupGridClicks();
      this._setupCartButton();
      this._setupKeyboard();
      this._setupProductOverlay();
      this._setupCartDrawer();
      this._setupAboutMenu();
      this._setupInfoModal();
      this._setupVacationNotice();

      this._refreshCartCount();

      /* ── ローダー判定（管理画面プレビュー時はスキップ） ──────────────── */
      this._loaderEl = document.getElementById('summit-loader');
      var inDesign   = typeof Shopify !== 'undefined' && Shopify.designMode;

      if (this._loaderEl && !inDesign) {
        this._runLoader();
      } else if (this._loaderEl) {
        this._loaderEl.style.display = 'none';
        this._loaderEl = null;
        this._showVacationNoticeIfNeeded();
      }
    }

    /* ── ローディング（0%→100%カウントアップ） ──────────────────────── */

    _runLoader() {
      var self     = this;
      var loader   = this._loaderEl;
      var pctEl    = document.getElementById('summit-loader-pct');
      var DURATION = 2200; // ms（固定時間。実ロード速度に依存しない）

      // グリッドをローダー背後で非表示にしておき、完了後にフェードイン
      this.style.opacity    = '0';
      this.style.transition = 'none';

      // Date.now() で起点を取得（rAF タイムスタンプに依存しない壁時計ベース）
      var startTime = Date.now();

      function tick() {
        var elapsed = Date.now() - startTime;
        var t       = Math.min(elapsed / DURATION, 1);
        var eased   = 1 - Math.pow(1 - t, 3); // easeOutCubic
        var pct     = Math.round(eased * 100);
        if (pctEl) pctEl.textContent = pct + '%';

        if (t < 1) {
          requestAnimationFrame(tick);
        } else {
          if (pctEl) pctEl.textContent = '100%';

          // 100% を短時間表示してからフェードアウト → グリッドをフェードイン
          setTimeout(function () {
            self.style.transition = 'opacity 0.6s ease 0.1s';
            self.style.opacity    = '1';
            if (loader) loader.classList.add('is-exiting');
            self._showVacationNoticeIfNeeded();
            setTimeout(function () {
              if (loader) loader.style.display = 'none';
              self._loaderEl = null;
            }, 800);
          }, 200);
        }
      }

      requestAnimationFrame(tick);
    }

    /* ── 商品データ JSON 読み込み ────────────────────────────────────── */

    _parseProductsData() {
      var el = document.getElementById('summit-products-data');
      if (!el) return [];
      try { return JSON.parse(el.textContent || '[]'); } catch (e) { return []; }
    }

    /* ── グリッドアイテムクリック → モバイルはページ遷移、PC はモーダル ─ */

    _setupGridClicks() {
      var self = this;
      this.addEventListener('click', function (e) {
        var item = e.target.closest('.summit-grid__item');
        if (!item || !item.dataset.productUrl) return;
        /* モバイルは <a href> のネイティブ遷移に任せる */
        if (window.innerWidth < 750) return;
        e.preventDefault();
        var pi = parseInt(item.dataset.productIndex, 10);
        if (!isNaN(pi)) self._openProductOverlay(pi);
      });
    }

    /* ── カートボタン（ヘッダー右上） ────────────────────────────────── */

    _setupCartButton() {
      var self = this;
      var btn  = document.getElementById('summit-grid-cart-btn');
      if (btn) btn.addEventListener('click', function () { self._openCartDrawer(); });
    }

    /* ── キーボード（Escape で閉じる） ───────────────────────────────── */

    _setupKeyboard() {
      var self = this;
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          self._closeProductOverlay();
          self._closeCartDrawer();
          if (self._closeAboutMenu) self._closeAboutMenu();
          if (self._closeInfoModal) self._closeInfoModal();
          if (self._closeVacationNotice) self._closeVacationNotice();
        }
      });
    }

    /* ── About メニュー（ⓘ ボタンでトグル） ─────────────────────────── */

    _setupAboutMenu() {
      var btn  = document.getElementById('summit-about-btn');
      var menu = document.getElementById('summit-about-menu');
      if (!btn || !menu) return;

      function closeAbout() {
        menu.classList.remove('is-open');
        menu.setAttribute('aria-hidden', 'true');
        btn.setAttribute('aria-expanded', 'false');
      }

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = menu.classList.contains('is-open');
        if (isOpen) {
          closeAbout();
        } else {
          menu.classList.add('is-open');
          menu.setAttribute('aria-hidden', 'false');
          btn.setAttribute('aria-expanded', 'true');
        }
      });

      // メニュー外クリックで閉じる
      document.addEventListener('click', function (e) {
        if (!menu.classList.contains('is-open')) return;
        if (e.target.closest('#summit-about-btn, #summit-about-menu')) return;
        closeAbout();
      });

      this._closeAboutMenu = closeAbout;
    }

    /* ── 情報モーダル（LEGAL NOTICE / PRIVACY POLICY） ────────────────── */

    _setupInfoModal() {
      var self  = this;
      var modal = document.getElementById('summit-info-modal');
      if (!modal) return;

      var panel    = modal.querySelector('.summit-info-modal__panel');
      var titleEl  = document.getElementById('summit-info-modal-title');
      var bodyEl   = document.getElementById('summit-info-modal-body');
      var backdrop = modal.querySelector('.summit-info-modal__backdrop');
      var closeBtn = modal.querySelector('.summit-info-modal__close');

      function openModal(key, title) {
        var contentEl = document.getElementById('summit-content-' + key);
        if (titleEl) titleEl.textContent = title;
        if (bodyEl && contentEl) bodyEl.innerHTML = contentEl.innerHTML;
        modal.classList.remove('is-closing');
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        if (closeBtn) closeBtn.focus();
      }

      function closeModal() {
        if (!modal.classList.contains('is-open')) return;
        modal.classList.remove('is-open');
        modal.classList.add('is-closing');
        var done = false;
        function finish() {
          if (done) return;
          done = true;
          modal.classList.remove('is-closing');
          modal.setAttribute('aria-hidden', 'true');
        }
        if (panel) panel.addEventListener('animationend', finish, { once: true });
        setTimeout(finish, 1600); // 1.4s + 余裕
      }

      document.querySelectorAll('[data-info-modal]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          var key   = btn.getAttribute('data-info-modal');
          var title = btn.getAttribute('data-info-title') || key;
          if (self._closeAboutMenu) self._closeAboutMenu();
          openModal(key, title);
        });
      });

      if (backdrop) backdrop.addEventListener('click', closeModal);
      if (closeBtn) closeBtn.addEventListener('click', closeModal);

      self._closeInfoModal = closeModal;
    }

    /* ── 発送休止のお知らせモーダル（ロード完了後に自動表示） ─────────── */

    _setupVacationNotice() {
      var self  = this;
      var modal = document.getElementById('summit-vacation-modal');
      self._showVacationNoticeIfNeeded = function () {};
      if (!modal) return;

      var panel    = modal.querySelector('.summit-info-modal__panel');
      var backdrop = modal.querySelector('.summit-info-modal__backdrop');
      var closeBtn = modal.querySelector('.summit-info-modal__close');

      function closeModal() {
        if (!modal.classList.contains('is-open')) return;
        modal.classList.remove('is-open');
        modal.classList.add('is-closing');
        var done = false;
        function finish() {
          if (done) return;
          done = true;
          modal.classList.remove('is-closing');
          modal.setAttribute('aria-hidden', 'true');
        }
        if (panel) panel.addEventListener('animationend', finish, { once: true });
        setTimeout(finish, 1600); // 1.4s + 余裕
      }

      function openModal() {
        modal.classList.remove('is-closing');
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        if (closeBtn) closeBtn.focus();
        try { sessionStorage.setItem('summitVacationNoticeShown', '1'); } catch (e) {}
      }

      if (backdrop) backdrop.addEventListener('click', closeModal);
      if (closeBtn) closeBtn.addEventListener('click', closeModal);

      self._closeVacationNotice = closeModal;

      // 管理画面プレビュー（designMode）中は設定確認のため毎回表示。
      // 通常表示時は1セッション中1回のみ表示（sessionStorageで判定）。
      self._showVacationNoticeIfNeeded = function () {
        var inDesign     = typeof Shopify !== 'undefined' && Shopify.designMode;
        var alreadyShown = false;
        try { alreadyShown = sessionStorage.getItem('summitVacationNoticeShown') === '1'; } catch (e) {}
        if (inDesign || !alreadyShown) openModal();
      };
    }

    /* ════════════════════════════════════════════════════════════════════
       商品オーバーレイ（damso スタイル）
    ════════════════════════════════════════════════════════════════════ */

    _setupProductOverlay() {
      var overlay = this._prodOverlay;
      if (!overlay) return;
      var self = this;

      // 背景クリックで閉じる
      var backdrop = overlay.querySelector('.summit-overlay__backdrop');
      backdrop && backdrop.addEventListener('click', function () { self._closeProductOverlay(); });

      // ✕ ボタンで閉じる
      var closeBtn = overlay.querySelector('.summit-overlay__close');
      closeBtn && closeBtn.addEventListener('click', function () { self._closeProductOverlay(); });

      // ‹ / › で同一商品の前後画像
      var imgPrevBtn = overlay.querySelector('.summit-overlay__img-prev');
      imgPrevBtn && imgPrevBtn.addEventListener('click', function () {
        self._renderOverlayImage(Math.max(0, self._overlayImgIdx - 1));
      });
      var imgNextBtn = overlay.querySelector('.summit-overlay__img-next');
      imgNextBtn && imgNextBtn.addEventListener('click', function () {
        self._renderOverlayImage(Math.min(self._overlayImages.length - 1, self._overlayImgIdx + 1));
      });

      // ADD TO CART: マルチサイズは選択済みチップのバリアントを追加（未選択なら案内表示）、
      // 単一サイズは即追加
      var addBtn = overlay.querySelector('.summit-overlay__add-btn');
      if (addBtn) {
        addBtn.addEventListener('click', function () {
          var data = (self._overlayProductIdx != null) ? self._products[self._overlayProductIdx] : null;
          var variants = (data && data.variants) ? data.variants : [];
          var hasRealSizes = variants.length > 1 ||
            (variants.length === 1 && variants[0].title !== 'Default Title');

          if (hasRealSizes) {
            if (self._sizeSelected && self._selVariantId) {
              self._handleAddToCart(self._selVariantId);
            } else {
              var statusEl = overlay.querySelector('.summit-overlay__status');
              if (statusEl) statusEl.textContent = 'サイズを選択してください';
            }
          } else {
            var defaultId = variants.length > 0 ? variants[0].id : null;
            if (defaultId) self._handleAddToCart(defaultId);
          }
        });
      }

      // サイズチップ: クリックで選択（◯囲み）し、価格表示を選択サイズに切り替える
      var chipsEl = overlay.querySelector('.summit-overlay__size-chips');
      if (chipsEl) {
        chipsEl.addEventListener('click', function (e) {
          var chip = e.target.closest('.summit-overlay__size-chip');
          if (!chip || chip.disabled) return;
          chipsEl.querySelectorAll('.summit-overlay__size-chip').forEach(function (c) {
            c.classList.remove('is-selected');
            c.setAttribute('aria-pressed', 'false');
          });
          chip.classList.add('is-selected');
          chip.setAttribute('aria-pressed', 'true');
          self._selVariantId = parseInt(chip.dataset.variantId, 10) || null;
          self._sizeSelected = true;
          self._updatePrice();
          var statusEl = overlay.querySelector('.summit-overlay__status');
          if (statusEl) statusEl.textContent = '';
        });
      }

      // 画像スワイプは scroll-snap によるブラウザネイティブスクロールで処理。
      // scroll イベントで _overlayImgIdx と矢印状態を同期（_injectOverlayContent で毎回設定）。

      // MORE INFO トグル（画像上にオーバーレイ表示）
      var infoToggle = overlay.querySelector('.summit-overlay__info-toggle');
      if (infoToggle) {
        infoToggle.addEventListener('click', function () {
          var expanded  = infoToggle.getAttribute('aria-expanded') === 'true';
          var imageWrap = overlay.querySelector('.summit-overlay__image-wrap');
          var detail    = overlay.querySelector('.summit-overlay__info-detail');
          infoToggle.setAttribute('aria-expanded', String(!expanded));
          infoToggle.textContent = expanded ? 'MORE INFO' : 'LESS INFO';
          if (imageWrap) imageWrap.classList.toggle('is-info-open', !expanded);
          if (detail) {
            detail.classList.toggle('is-open', !expanded);
            detail.setAttribute('aria-hidden', String(expanded));
          }
        });
      }
    }

    _injectOverlayContent(productIndex) {
      var data    = this._products[productIndex];
      var overlay = this._prodOverlay;
      if (!overlay) return;

      this._overlayProductIdx = productIndex;
      this._selVariantId      = null;
      this._sizeSelected      = false; // サイズ未選択（チップクリックで true）

      // 商品名
      var nameEl = overlay.querySelector('.summit-overlay__name');
      if (nameEl) nameEl.textContent = (data && data.title) ? data.title.toUpperCase() : '';

      // MORE INFO・サイズチップをリセット（閉じた状態に戻す）
      var imageWrap  = overlay.querySelector('.summit-overlay__image-wrap');
      var infoToggle = overlay.querySelector('.summit-overlay__info-toggle');
      var infoDetail = overlay.querySelector('.summit-overlay__info-detail');
      if (imageWrap) imageWrap.classList.remove('is-info-open');
      if (infoDetail) {
        infoDetail.classList.remove('is-open');
        infoDetail.setAttribute('aria-hidden', 'true');
      }
      if (infoToggle) {
        infoToggle.setAttribute('aria-expanded', 'false');
        infoToggle.textContent = 'MORE INFO';
      }

      // 説明テキスト
      var descEl = overlay.querySelector('.summit-overlay__description');
      if (descEl) {
        var desc = (data && data.description) ? data.description.trim() : '';
        descEl.innerHTML = desc;
      }

      // 画像
      var images = (data && data.images && data.images.length > 0)
        ? data.images
        : (data && data.image ? [data.image] : []);
      this._overlayImages = images;
      this._overlayImgIdx = 0;

      // 画像トラックを再構築
      var trackEl = overlay.querySelector('.summit-overlay__img-track');
      if (trackEl) {
        trackEl.innerHTML = '';
        trackEl.scrollLeft = 0;
        images.forEach(function (src) {
          var img = document.createElement('img');
          img.className = 'summit-overlay__img';
          img.src       = src;
          img.alt       = '';
          img.width     = 520;
          img.height    = 650; // 4:5（表示枠 .summit-overlay__image-wrap の aspect-ratio と一致）
          img.loading   = 'lazy';
          trackEl.appendChild(img);
        });

        // scroll-snap のスクロール量からインデックスを同期
        trackEl.addEventListener('scroll', function () {
          var w = trackEl.clientWidth;
          if (!w) return;
          var newIdx = Math.round(trackEl.scrollLeft / w);
          if (newIdx === self._overlayImgIdx) return;
          self._overlayImgIdx = newIdx;
          var total   = self._overlayImages.length;
          var prevBtn = overlay.querySelector('.summit-overlay__img-prev');
          var nextBtn = overlay.querySelector('.summit-overlay__img-next');
          if (prevBtn) { prevBtn.disabled = newIdx === 0; }
          if (nextBtn) { nextBtn.disabled = newIdx === total - 1; }
        }, { passive: true });
      }

      // ‹ › 矢印の初期状態を確定（track が構築された後）
      this._renderOverlayImage(0);

      // SIZE チップを事前生成（非表示状態で）
      var chipsEl      = overlay.querySelector('.summit-overlay__size-chips');
      var variants     = (data && data.variants) ? data.variants : [];
      var self         = this;
      var hasRealSizes = variants.length > 1 ||
        (variants.length === 1 && variants[0].title !== 'Default Title');

      if (chipsEl) {
        chipsEl.innerHTML = '';
        if (hasRealSizes) {
          variants.forEach(function (v) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'summit-overlay__size-chip' + (!v.available ? ' is-unavailable' : '');
            btn.textContent = v.title;
            btn.dataset.variantId = v.id;
            btn.setAttribute('aria-pressed', 'false');
            if (!v.available) btn.disabled = true;
            chipsEl.appendChild(btn);
          });
        }
      }

      if (variants.length > 0) this._selVariantId = variants[0].id;
      this._updateAddCartLabel();

      var statusEl = overlay.querySelector('.summit-overlay__status');
      if (statusEl) statusEl.textContent = '';
    }

    _openProductOverlay(productIndex) {
      var overlay = this._prodOverlay;
      if (!overlay) return;

      // 中身を先に確定（アニメ中のレイアウトずれ防止）
      this._injectOverlayContent(productIndex);

      // is-closing を外して閉じアニメを停止
      overlay.classList.remove('is-closing');

      // パネルのアニメをリセット（前回の summit-modal-up が残ると頭から再生されないため）
      var panel = overlay.querySelector('.summit-overlay__panel');
      if (panel) {
        panel.style.animation = 'none';
        void panel.offsetHeight; // reflow で基底状態に戻す
        panel.style.animation  = '';
      }

      // 中身確定後に is-open でアニメ開始
      overlay.setAttribute('aria-hidden', 'false');
      overlay.classList.add('is-open');

      var closeBtnEl = overlay.querySelector('.summit-overlay__close');
      if (closeBtnEl) closeBtnEl.focus();
    }

    _closeProductOverlay() {
      var overlay = this._prodOverlay;
      if (!overlay) return;
      if (!overlay.classList.contains('is-open')) return; // 既に閉じている

      overlay.classList.remove('is-open');
      overlay.classList.add('is-closing');

      // アニメ終了後に完全非表示にする（animationend + タイムアウトの二重保険）
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        overlay.classList.remove('is-closing');
        overlay.setAttribute('aria-hidden', 'true');
      }

      var panel = overlay.querySelector('.summit-overlay__panel');
      if (panel) panel.addEventListener('animationend', finish, { once: true });
      setTimeout(finish, 700); // 0.5s + 余裕
    }

    _renderOverlayImage(idx) {
      var overlay = this._prodOverlay;
      if (!overlay) return;
      var total = this._overlayImages.length;
      idx = Math.max(0, Math.min(total - 1, idx));
      this._overlayImgIdx = idx;

      var trackEl = overlay.querySelector('.summit-overlay__img-track');
      if (trackEl) trackEl.scrollTo({ left: idx * trackEl.clientWidth, behavior: 'smooth' });

      // ‹ › ボタンの有効/無効状態を更新
      var prevBtn = overlay.querySelector('.summit-overlay__img-prev');
      var nextBtn = overlay.querySelector('.summit-overlay__img-next');
      var showArrows = total > 1;
      if (prevBtn) {
        prevBtn.style.visibility = showArrows ? '' : 'hidden';
        prevBtn.disabled = idx === 0;
      }
      if (nextBtn) {
        nextBtn.style.visibility = showArrows ? '' : 'hidden';
        nextBtn.disabled = idx === total - 1;
      }
    }

    _updateAddCartLabel() {
      var overlay = this._prodOverlay;
      if (!overlay) return;
      var addBtn = overlay.querySelector('.summit-overlay__add-btn');
      if (!addBtn) return;
      addBtn.textContent = 'ADD TO CART';
      addBtn.disabled = false;
      this._updatePrice();
    }

    _updatePrice() {
      var overlay = this._prodOverlay;
      if (!overlay) return;
      var priceEl = overlay.querySelector('.summit-overlay__price');
      if (!priceEl) return;
      var data     = (this._overlayProductIdx != null) ? this._products[this._overlayProductIdx] : null;
      var variants = (data && data.variants) ? data.variants : [];
      var selId    = this._selVariantId;
      var v        = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === selId) { v = variants[i]; break; }
      }
      if (!v && variants.length > 0) v = variants[0];
      priceEl.textContent = (v && v.price) ? (v.price + 'yen') : '';
    }

    /* ── ADD TO CART（Ajax /cart/add.js） ───────────────────────────── */

    _handleAddToCart(variantId) {
      if (!variantId) return;

      var overlay  = this._prodOverlay;
      var addBtn   = overlay ? overlay.querySelector('.summit-overlay__add-btn') : null;
      var statusEl = overlay ? overlay.querySelector('.summit-overlay__status')   : null;
      var self     = this;

      if (addBtn) { addBtn.textContent = 'ADDING...'; addBtn.disabled = true; }
      if (statusEl) statusEl.textContent = '';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.json();
      })
      .then(function () {
        if (addBtn) { addBtn.textContent = 'ADDED ✓'; addBtn.disabled = false; }
        self._refreshCartCount();
        setTimeout(function () { self._updateAddCartLabel(); }, 2000);
      })
      .catch(function () {
        self._updateAddCartLabel();
        if (statusEl) statusEl.textContent = 'エラーが発生しました。再度お試しください。';
      });
    }

    /* ════════════════════════════════════════════════════════════════════
       カートドロワー
    ════════════════════════════════════════════════════════════════════ */

    _setupCartDrawer() {
      var drawer = this._cartDrawer;
      if (!drawer) return;
      var self     = this;
      var backdrop = drawer.querySelector('.summit-drawer__backdrop');
      var closeBtn = drawer.querySelector('.summit-drawer__close');

      backdrop && backdrop.addEventListener('click', function () { self._closeCartDrawer(); });
      closeBtn && closeBtn.addEventListener('click', function () { self._closeCartDrawer(); });

      // 数量変更・削除: パネルへの委譲（innerHTML 更新後も有効）
      var panel = drawer.querySelector('.summit-drawer__panel');
      if (panel) {
        panel.addEventListener('click', function (e) {
          var removeBtn = e.target.closest('[data-cart-remove]');
          if (removeBtn) {
            self._cartChange(removeBtn.dataset.cartRemove, 0);
            return;
          }
          var qtyBtn = e.target.closest('[data-cart-qty-delta]');
          if (qtyBtn) {
            var ctrl      = qtyBtn.closest('.summit-drawer__qty-ctrl');
            var numEl     = ctrl && ctrl.querySelector('.summit-drawer__qty-num');
            var currentQty = numEl ? parseInt(numEl.textContent, 10) : 1;
            var delta      = parseInt(qtyBtn.dataset.cartQtyDelta, 10);
            var newQty     = Math.max(0, currentQty + delta);
            self._cartChange(qtyBtn.dataset.cartKey, newQty);
          }
        });
      }
    }

    _cartChange(key, quantity) {
      var self = this;
      fetch('/cart/change.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body:    JSON.stringify({ id: key, quantity: quantity })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        self._renderCartDrawer();
        self._refreshCartCount();
      })
      .catch(function () {});
    }

    _openCartDrawer() {
      if (!this._cartDrawer) return;
      this._cartDrawer.setAttribute('aria-hidden', 'false');
      this._renderCartDrawer();
      var closeBtn = this._cartDrawer.querySelector('.summit-drawer__close');
      if (closeBtn) closeBtn.focus();
    }

    _closeCartDrawer() {
      if (!this._cartDrawer) return;
      this._cartDrawer.setAttribute('aria-hidden', 'true');
    }

    _renderCartDrawer() {
      var drawer  = this._cartDrawer;
      var itemsEl = drawer ? drawer.querySelector('.summit-drawer__items') : null;
      var totalEl = drawer ? drawer.querySelector('.summit-drawer__total') : null;
      var self    = this;

      if (itemsEl) itemsEl.innerHTML = '<p class="summit-drawer__loading">読み込み中...</p>';

      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!itemsEl) return;
        itemsEl.innerHTML = '';

        if (!cart.items || cart.items.length === 0) {
          itemsEl.innerHTML = '<p class="summit-drawer__empty">カートは空です</p>';
          if (totalEl) totalEl.textContent = '';
          return;
        }

        cart.items.forEach(function (item) {
          var div       = document.createElement('div');
          div.className = 'summit-drawer__item';
          var imgSrc    = item.image ? (item.image.startsWith('//') ? 'https:' + item.image : item.image) : '';
          var title     = item.product_title || item.title || '';
          var variant   = (item.variant_title && item.variant_title !== 'Default Title')
                            ? item.variant_title : '';
          var linePrice = formatMoney(item.line_price, self._moneyFmt);

          var k = esc(item.key);
          div.innerHTML =
            '<div class="summit-drawer__item-img-wrap">' +
              (imgSrc ? '<img src="' + esc(imgSrc) + '" alt="' + esc(title) + '" class="summit-drawer__item-img" loading="lazy">' : '') +
            '</div>' +
            '<div class="summit-drawer__item-info">' +
              '<div class="summit-drawer__item-header">' +
                '<div class="summit-drawer__item-title">' + esc(title.toUpperCase()) + '</div>' +
                '<button class="summit-drawer__item-remove" type="button" data-cart-remove="' + k + '" aria-label="削除">✕</button>' +
              '</div>' +
              (variant ? '<div class="summit-drawer__item-variant">' + esc(variant.toUpperCase()) + '</div>' : '') +
              '<div class="summit-drawer__item-bottom">' +
                '<div class="summit-drawer__qty-ctrl">' +
                  '<button class="summit-drawer__qty-btn" type="button" data-cart-key="' + k + '" data-cart-qty-delta="-1" aria-label="数量を減らす">−</button>' +
                  '<span class="summit-drawer__qty-num">' + item.quantity + '</span>' +
                  '<button class="summit-drawer__qty-btn" type="button" data-cart-key="' + k + '" data-cart-qty-delta="1" aria-label="数量を増やす">+</button>' +
                '</div>' +
                '<span class="summit-drawer__item-price">' + esc(linePrice) + '</span>' +
              '</div>' +
            '</div>';

          itemsEl.appendChild(div);
        });

        if (totalEl) {
          totalEl.textContent = 'TOTAL  ' + formatMoney(cart.total_price, self._moneyFmt);
        }
      })
      .catch(function () {
        if (itemsEl) itemsEl.innerHTML = '<p class="summit-drawer__empty">読み込みエラー</p>';
      });
    }

    /* ── カート点数バッジ更新 ─────────────────────────────────────────── */

    _refreshCartCount() {
      var countEl = document.getElementById('summit-grid-cart-count');
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = cart.item_count || 0;
        if (countEl) {
          countEl.textContent   = n;
          countEl.style.display = n > 0 ? '' : 'none';
        }
      })
      .catch(function () {});
    }
  }

  if (!customElements.get('summit-grid')) {
    customElements.define('summit-grid', SummitGrid);
  }
})();
